import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface ICaraCallEnded {
  readonly id: string;
  readonly type: MESSAGES.CARA_CALL_ENDED;
  readonly rm: boolean;
  readonly role: ROLE.BOT;
  readonly avatar: boolean;
  readonly durationMs: number;
}

export const createCaraCallEnded = (data: {
  id?: string;
  _id?: string;
  durationMs?: number;
}): ICaraCallEnded => ({
  id: data.id ?? data._id ?? uuid(),
  type: MESSAGES.CARA_CALL_ENDED,
  rm: false,
  role: ROLE.BOT,
  avatar: true,
  durationMs: data.durationMs ?? 0,
});
